//Add span Classes to the Checkbox and Radio buttons for Web Forms for Marketers
$("<span></span>").insertAfter(".radio label input");
$("<span></span>").insertAfter(".checkbox label input");
$(".form-group:has(select)").addClass("form-group--select");
$( ".form-control.datepicker" ).datepicker({dateFormat: "dd-M-yy"});


